module.exports = __webpack_public_path__ + "static/media/car-sideview.750ae3b5.svg";